import React, { useEffect, useState, useRef, useCallback, useContext } from "react";
import { IInappNotifications } from "../../../interfaces/InAppNotification";
import {
    Box,
    Button,
    Grid,
    useMediaQuery,
    useTheme,
    Typography,
} from "@mui/material";
import moment from "moment";
import {
    getNotifications,
    updateNotificationCount,
    getNotificationCount,
} from "../../../Utils/apiService";
import { Navigate, useNavigate } from "react-router-dom";
import notify_loader from "../../../Assets/notification.svg";
// import alerts_icon from "../../../Assets/notification.svg";
import emptyNotification from '../../../Assets/emptyNotification.svg'
import Profile from "../../../Assets/notification.svg";
import nodata_icon from "../../../Assets/notification.svg";
import Configurl from "../../../Configurl";
import { AuthContext } from "../../../Helpers/Contexts/authContext";
import { AuthUser } from "../../../interfaces/Contexts";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import defultNotification from "../../../Assets/icons/defultNotification.svg";
interface INotification {
    id: any;
    day: any;
    title: string;
    body: string;
    url: string;
    topic: string;
    imageUrl?: string; // Optional image field
    timestamp: number;
    type: any;
    userId?: string; // Added userId to match notifications with the user
    seenStatus?: boolean;
    navigatingFunction: (
        url: string,
        title: string,
        body: string,
        id: string,
        templateId: string
    ) => void;
}

interface IGroupedNotifications {
    today: INotification[];
    yesterday: INotification[];
    thisWeek: INotification[];
    earlier: INotification[];
}

const InAppNotifications: React.FC<IInappNotifications> = ({
    anchorEl,
    handleClosePopover,
    openpop,
    onNotificationCountUpdate,
}) => {

    const {
        state: { user },
    } = useContext(AuthContext);
    const userData = user as AuthUser;
    const ismobile = useMediaQuery("(max-width: 600px)");
    const theme = useTheme();
    const BASE_URL_LIVE = Configurl.apiBaseUrl;
    const isMobilescreen = useMediaQuery(theme.breakpoints.down("sm"));
    const [perpage, setPerPage] = useState(20);
    const [curPage, setCurPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [isFetchingMore, setIsFetchingMore] = useState(false);
    const [groupedNotifications, setGroupedNotifications] =
        useState<IGroupedNotifications>({
            today: [],
            yesterday: [],
            thisWeek: [],
            earlier: [],
        });
    console.log(groupedNotifications, "groupedNotificationsgroupedNotificationsgroupedNotificationsgroupedNotifications");

    const [tabIndex, setTabIndex] = useState(0);
    const containerRef = useRef<HTMLDivElement>(null);
    const [message, setMessage] = useState("");
    const [totalPages, setTotalPages] = useState(0);
    const [notificationsList, setNotificationsList] = useState<INotification[]>(
        []
    );
    const navigate = useNavigate();
    const userid = userData?.applicantId;
    const isFirstRun = useRef(true);
    const scrollPositionRef = useRef<number>(0);
    const [unreadNotifications, setUnreadNotifications] = useState<any[]>([]);
    const role = sessionStorage.getItem("role");

    // Track which notifications have been auto-marked as read
    const autoMarkedRef = useRef<Set<string>>(new Set());

    // Helper to mark first N unread notifications as read (auto)
    const markFirstNUnreadAsRead = useCallback(async (n: number) => {
        const unread = notificationsList
            .filter(noti => !noti.seenStatus && !autoMarkedRef.current.has(noti.id))
            .slice(0, n);

        if (unread.length === 0) return;

        const markPayload = unread.map(noti => ({ [noti.id]: true }));
        try {
            await updateNotificationCount(markPayload);
            setUnreadNotifications(prev =>
                prev.filter(id => !unread.some(noti => noti.id === id))
            );
            // Mark as auto-marked to avoid duplicate marking
            unread.forEach(noti => autoMarkedRef.current.add(noti.id));
            // Optionally update notification count in parent
            if (onNotificationCountUpdate) {
                onNotificationCountUpdate(
                    unreadNotifications.length - unread.length
                );
            }
        } catch (err) {
            // handle error if needed
        }
    }, [notificationsList, unreadNotifications, onNotificationCountUpdate]);

    const fetchData = async (page = curPage) => {
        try {
            if (isFetchingMore) return; // Prevent duplicate calls
            const tabType = tabIndex === 0 ? "alert" : "notification";
            const container = document.getElementById("scrollable-container");
            const currentScrollTop = container ? container.scrollTop : 0;
            // Fetch data from API
            const res = await getNotifications(page, perpage, userid, tabType);

            if (res?.data.status === "success") {
                setTotalPages(res?.data.totalPages || 0);

                // Extract notifications from the new response structure
                const notificationsObj = res?.data?.data?.[0]?.notifications || {};
                const notificationsArray = Object.entries(notificationsObj).map(
                    ([id, notification]: [string, any]) => ({
                        id,
                        ...notification,
                    })
                );

                // Now notificationsArray is an array of notification objects with id
                setNotificationsList((prevList) => {
                    const updatedList = [...prevList, ...notificationsArray];
                    setGroupedNotifications(groupNotificationsByDate(updatedList));
                    return updatedList;
                });

                const newUnreadIds = notificationsArray
                    .filter((notif) => !notif.seenStatus)
                    .map((notif) => notif.id);

                setUnreadNotifications((prevUnread) => [
                    ...new Set([...prevUnread, ...newUnreadIds]),
                ]);

                requestAnimationFrame(() => {
                    if (container) {
                        container.scrollTop = currentScrollTop;
                    }
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setMessage("Error fetching notifications");
        } finally {
            setLoading(false);
            setIsFetchingMore(false);
        }
    };

    useEffect(() => {
        if (openpop) {
            console.log("Tab changed to:", tabIndex);

            // Reset states properly before fetching new data
            setLoading(true);

            setNotificationsList([]); // Clears the previous data
            setCurPage(1);
            fetchData(1); // Fetch from the first page

            console.log("grouped", groupedNotifications);
            autoMarkedRef.current = new Set(); // Reset on open
        }
    }, [openpop, tabIndex]);

    useEffect(() => {
        if (curPage > 1) {
            setIsFetchingMore(true);
            fetchData();
        }
    }, [curPage]);

    // After notificationsList changes (i.e., after fetch), mark next 5 unread as read only in Unread tab
    useEffect(() => {
        if (openpop && notificationsList.length > 0 && tabIndex === 1) {
            markFirstNUnreadAsRead(5);
        }
    }, [notificationsList, openpop, markFirstNUnreadAsRead, tabIndex]);

    const markAllAsSeen = async () => {
        try {
            setLoading(true);

            let allUnreadNotificationIds: any = [];
            let currentPage = 1;
            let totalPages = 1;

            // Loop through all pages to retrieve notifications
            while (currentPage <= totalPages) {
                const res = await getNotificationCount(currentPage, perpage, userid);
                console.log("Notification count on page", currentPage, ":", res);

                if (res && res.data && res.data.data.length > 0) {
                    // Extract notifications from the response
                    const notifications = res.data.data[0]; // Assuming data is an array with a single object

                    // Filter unread notifications (seenStatus = false)
                    const unreadNotificationKeys = Object.keys(notifications).filter(
                        (key) => notifications[key].seenStatus === false
                    );

                    allUnreadNotificationIds = [
                        ...allUnreadNotificationIds,
                        ...unreadNotificationKeys,
                    ];
                }

                // Set totalPages from response to determine how many pages to fetch
                totalPages = res.data.totalPages || 1;
                currentPage++;
            }

            if (allUnreadNotificationIds.length === 0) {
                console.log("No unread notifications.");
                return;
            }

            console.log(`Total unread: ${allUnreadNotificationIds.length}`);

            const BATCH_SIZE = 200;
            const batches = [];

            // Split unread notifications into batches for API calls
            for (let i = 0; i < allUnreadNotificationIds.length; i += BATCH_SIZE) {
                const batch = allUnreadNotificationIds
                    .slice(i, i + BATCH_SIZE)
                    .map((notificationId: any) => ({
                        [notificationId]: true, // Mark as read
                    }));

                // Push API call promise to the batch array
                batches.push(updateNotificationCount(batch));
            }

            // Execute all batch requests in parallel
            await Promise.all(batches);
            console.log("All notifications marked as read.");

            setUnreadNotifications([]); // Reset unread notifications state

            // Update notification count in parent component
            if (onNotificationCountUpdate) {
                onNotificationCountUpdate(0);
            }
        } catch (error) {
            console.error("Error marking notifications as read:", error);
        } finally {
            setLoading(false);
        }
    };

    const markIndividualAsRead = async (notificationId?: string) => {
        try {
            if (notificationId) {
                const result = [{ [notificationId]: true }]; // Mark the specific notification as read
                const markRead = await updateNotificationCount(result);
                // Update the state to remove the marked notification from the unread list
                setUnreadNotifications((prevIds) => {
                    const newIds = prevIds.filter((id) => id !== notificationId);
                    if (onNotificationCountUpdate) {
                        onNotificationCountUpdate(newIds.length);
                    }
                    return newIds;
                });

                return; // Exit after marking the specific notification
            }
        } catch (error) {
            console.error("Error marking seen:", error);
        }
    };

    const debounceTimeoutRef = useRef<number | null>(null);

    const handleScroll = useCallback(
        (event: React.UIEvent<HTMLDivElement>) => {
            const target = event.target as HTMLDivElement;

            scrollPositionRef.current = target.scrollTop;
            const { scrollHeight, scrollTop, clientHeight } = target;

            const isBottomReached =
                Math.ceil(scrollTop + clientHeight) >= scrollHeight - 1;

            if (isBottomReached && !loading && curPage < totalPages) {
                if (debounceTimeoutRef.current) {
                    clearTimeout(debounceTimeoutRef.current);
                }

                debounceTimeoutRef.current = window.setTimeout(() => {
                    setCurPage((prevPage) => prevPage + 1);
                }, 300); // Debounce delay
            }
            // Only auto-mark as read in Unread tab
            if (tabIndex === 1) {
                markFirstNUnreadAsRead(5);
            }
        },
        [loading, curPage, totalPages, markFirstNUnreadAsRead, tabIndex]
    );

    useEffect(() => {
        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, []);

    const groupNotificationsByDate = (notificationsList: INotification[]) => {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        const thisWeekStart = new Date(today);
        thisWeekStart.setDate(today.getDate() - today.getDay());
        const groupedNotifications = {
            today: [] as INotification[],
            yesterday: [] as INotification[],
            thisWeek: [] as INotification[],
            earlier: [] as INotification[],
        };
        notificationsList.forEach((notification) => {
            const notificationDate = new Date(notification.timestamp);
            if (notificationDate.toDateString() === today.toDateString()) {
                groupedNotifications.today.push(notification);
            } else if (notificationDate.toDateString() === yesterday.toDateString()) {
                groupedNotifications.yesterday.push(notification);
            } else if (notificationDate >= thisWeekStart) {
                groupedNotifications.thisWeek.push(notification);
            } else {
                groupedNotifications.earlier.push(notification);
            }
        });
        return groupedNotifications;
    };

    const formatTitle = (title: any) => {
        // Replace underscores with spaces and capitalize the first letter
        return title
            .replace(/_/g, " ") // Replace all underscores with spaces
            .replace(/\b\w/g, (char: any) => char.toUpperCase()); // Capitalize the first letter of each word
    };

    const formatTime = (timestamp: number) => {
        return moment(timestamp).format("hh:mm a");
    };

    // Memoize filtered notifications based on tabIndex
    const filteredNotifications = React.useMemo(() => {
        if (tabIndex === 1) {
            // Unread
            return notificationsList.filter(n => n.seenStatus === false);
        } else if (tabIndex === 2) {
            // Read
            return notificationsList.filter(n => n.seenStatus === true);
        }
        // All
        return notificationsList;
    }, [tabIndex, notificationsList]);

    // Memoize grouped notifications for filtered list
    const groupedFilteredNotifications = React.useMemo(
        () => groupNotificationsByDate(filteredNotifications),
        [filteredNotifications]
    );

    const notificationContent = (
        <Box>
            <center>
                <Box sx={{ display: 'flex', alignContent: "center", alignItems: "center", width: '90%', mt: 1, mb: 2 }}>
                    <Button
                        onClick={() => setTabIndex(0)}
                        sx={{
                            flex: 1,
                            background: tabIndex === 0 ? '#2C60AA' : '#F3F4F6',
                            color: tabIndex === 0 ? '#fff' : '#0A0A0A',
                            fontWeight: tabIndex === 0 ? 500 : 400,
                            borderRadius: 0,
                            boxShadow: 'none',
                            fontSize: '14px',
                            textTransform: 'none',
                            '&:hover': {
                                background: '#2C60AA',
                                color: '#3d2c00',
                            },
                        }}
                    >
                        All
                    </Button>
                    <Button
                        onClick={() => setTabIndex(1)}
                        sx={{
                            flex: 1,
                            background: tabIndex === 1 ? '#2C60AA' : '#F3F4F6',
                            color: tabIndex === 1 ? '#fff' : '#0A0A0A',
                            fontWeight: tabIndex === 1 ? 500 : 400,
                            borderRadius: 0,
                            boxShadow: 'none',
                            fontSize: '14px',
                            textTransform: 'none',
                            '&:hover': {
                                background: '#2C60AA',
                                color: '#fff',
                            },
                        }}
                    >
                        Unread
                    </Button>
                    <Button
                        onClick={() => setTabIndex(2)}
                        sx={{
                            flex: 1,
                            background: tabIndex === 2 ? '#2C60AA' : '#F3F4F6',
                            color: tabIndex === 2 ? '#fff' : '#0A0A0A',
                            fontWeight: tabIndex === 2 ? 500 : 400,
                            borderRadius: 0,
                            boxShadow: 'none',
                            fontSize: '14px',
                            textTransform: 'none',
                            '&:hover': {
                                background: '#2C60AA',
                                color: '#fff',
                            },
                        }}
                    >
                        Read
                    </Button>
                </Box>
            </center>
            <Box ref={containerRef}
                onScroll={handleScroll}
                sx={{
                    maxHeight: "calc(60vh - 48px)", // Default height
                    overflowY: "auto",
                    padding: "16px",
                    backgroundColor: "#F7A70",
                    height: '60vh',
                    "@media (max-width: 600px)": {
                        maxHeight: "calc(100vh - 64px)", // Adjust for mobile
                    },
                }}>
                {tabIndex === 0 && (
                    <>
                        {loading ? (
                            <div style={{ textAlign: "center" }}>
                                <span>
                                    <img src={notify_loader} width="100px" height="100px" alt=""></img>
                                </span>
                            </div>
                        ) : notificationsList?.length === 0 ? (
                            <div style={{ textAlign: "center" }}>
                                <div>
                                    <img src={emptyNotification} width="200px" height="200px" alt="" />
                                </div>
                                <div style={{ fontSize: "14px", color: "#373A45" }}>
                                    You're all caught up! No new notifications at the moment.
                                </div>
                            </div>
                        ) : (
                            <>
                                {groupedNotifications.today.length > 0 && (
                                    <>
                                        <Typography
                                            sx={{
                                                fontSize: "10px",
                                                fontWeight: 400,
                                                textAlign: "center",
                                                mt: 1,
                                                color: "#5b4200"
                                            }}
                                        >
                                            Today
                                        </Typography>
                                        {groupedNotifications.today.map((notification: any, index: number) => (
                                            <div key={notification.id}>
                                                <Grid container spacing={2} sx={{ mt: index === 0 ? 1 : 0 }} onClick={() => { markIndividualAsRead(notification.id); navigate(`${notification.url}`); handleClosePopover(); }}>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                                        <Box sx={{ height: '42px', width: '42px' }}>
                                                            {tabIndex === 0 ? (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        width: "42px",
                                                                        height: "42px",
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={notification.imageUrl === "null" ? defultNotification : notification.imageUrl === "null" ? defultNotification : notification.imageUrl || defultNotification}
                                                                        style={{ width: notification.imageUrl === "null" || !notification.imageUrl ? "30px" : "40px", height: notification.imageUrl === "null" || !notification.imageUrl ? "40px" : "40px", border: notification.imageUrl === "null" || !notification.imageUrl ? undefined : "1px solid #5b4200", borderRadius: "10px" }}
                                                                        alt="alert"
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <img
                                                                    src={notification.imageUrl === "null" ? defultNotification : notification.imageUrl || defultNotification}
                                                                    height={'100%'}
                                                                    width={'100%'}
                                                                    style={{ borderRadius: '50%' }}
                                                                    alt="profile"
                                                                />
                                                            )}
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={7} sm={7} md={7} lg={7} xl={7} xxl={6.5} style={{ textAlign: 'left' }}>
                                                        <Typography sx={{ color: '#5b4200', fontWeight: 500, fontSize: '12px' }}>
                                                            {formatTitle(notification.title)}
                                                        </Typography>
                                                        <Typography sx={{ fontWeight: 400, fontSize: '11px', mt: 0.5, color: '#5b4200' }}>
                                                            {notification.body}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3} xxl={3.5}>
                                                        <Box sx={{ display: 'flex' }}>
                                                            {/* {(notification.templateId !== "ewaybill_expiry_in_app" || role === "SUB_BRANCH_USER") && (
                                                            <Button
                                                                size="small"
                                                                sx={{
                                                                    height: '20px',
                                                                    width: '3vw',
                                                                    borderRadius: '8px',
                                                                    padding: 0,
                                                                    minWidth: '3vw',
                                                                    backgroundColor: '#5b4200',
                                                                    '&:hover': {
                                                                        backgroundColor: '#5b4200',
                                                                        color: 'white',
                                                                    },
                                                                    color: 'white',
                                                                    fontSize: '8px',
                                                                    fontWeight: '500',
                                                                    textTransform: 'none',
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    if (unreadNotifications.includes(notification.id)) {
                                                                        markIndividualAsRead(notification.id);
                                                                    }
                                                                    notification?.navigatingFunction(
                                                                        notification.url,
                                                                        notification.title,
                                                                        notification.body,
                                                                        notification.id,
                                                                        notification.templateId
                                                                    );
                                                                }}
                                                            >
                                                                {notification.title === "margin_approval_request" ? "Take Action" : "View"}
                                                            </Button>
                                                        )} */}
                                                        </Box>
                                                        <Typography sx={{ fontWeight: 400, fontSize: '10px', mt: 0.5, textAlign: 'end', color: '#5b4200' }}>
                                                            {formatTime(notification.timestamp)}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <hr style={{ border: '1px solid #E6E6E8' }} />
                                            </div>
                                        ))}
                                    </>
                                )}
                                {groupedNotifications.yesterday.length > 0 && (
                                    <>
                                        <Typography
                                            sx={{
                                                fontSize: "10px",
                                                fontWeight: 400,
                                                textAlign: "center",
                                                mt: 1,
                                                color: "#5b4200"
                                            }}
                                        >
                                            Yesterday
                                        </Typography>
                                        {groupedNotifications.yesterday.map((notification: any, index: number) => (
                                            <div key={notification.id}>
                                                <Grid container spacing={2} sx={{ mt: index === 0 ? 1 : 0 }} onClick={() => { markIndividualAsRead(notification.id); navigate(`${notification.url}`); handleClosePopover(); }}>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                                        <Box sx={{ height: '42px', width: '42px' }}>
                                                            {tabIndex === 0 ? (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        width: "42px",
                                                                        height: "42px",
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={notification.imageUrl === "null" ? defultNotification : notification.imageUrl === "null" ? defultNotification : notification.imageUrl || defultNotification}
                                                                        style={{ width: notification.imageUrl === "null" || !notification.imageUrl ? "30px" : "40px", height: notification.imageUrl === "null" || !notification.imageUrl ? "40px" : "40px", border: notification.imageUrl === "null" || !notification.imageUrl ? undefined : "1px solid #5b4200", borderRadius: "10px" }}
                                                                        alt="alert"
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <img
                                                                    src={notification.imageUrl === "null" ? defultNotification : notification.imageUrl || defultNotification}
                                                                    height={'100%'}
                                                                    width={'100%'}
                                                                    style={{ borderRadius: '50%' }}
                                                                    alt="profile"
                                                                />
                                                            )}
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={7} sm={7} md={7} lg={7} xl={7} xxl={6.5} style={{ textAlign: 'left' }}>
                                                        <Typography sx={{ color: '#5b4200', fontWeight: 500, fontSize: '12px' }}>
                                                            {formatTitle(notification.title)}
                                                        </Typography>
                                                        <Typography sx={{ fontWeight: 400, fontSize: '11px', mt: 0.5, color: '#5b4200' }}>
                                                            {notification.body}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3} xxl={3.5}>
                                                        <Box sx={{ display: 'flex' }}>
                                                            {/* {(notification.templateId !== "ewaybill_expiry_in_app" || role === "SUB_BRANCH_USER") && (
                                                            <Button
                                                                size="small"
                                                                sx={{
                                                                    height: '20px',
                                                                    width: '3vw',
                                                                    borderRadius: '8px',
                                                                    padding: 0,
                                                                    minWidth: '3vw',
                                                                    backgroundColor: '#5b4200',
                                                                    '&:hover': {
                                                                        backgroundColor: '#5b4200',
                                                                        color: 'white',
                                                                    },
                                                                    color: 'white',
                                                                    fontSize: '8px',
                                                                    fontWeight: '500',
                                                                    textTransform: 'none',
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    if (unreadNotifications.includes(notification.id)) {
                                                                        markIndividualAsRead(notification.id);
                                                                    }
                                                                    notification?.navigatingFunction(
                                                                        notification.url,
                                                                        notification.title,
                                                                        notification.body,
                                                                        notification.id,
                                                                        notification.templateId
                                                                    );
                                                                }}
                                                            >
                                                                {notification.title === "margin_approval_request" ? "Take Action" : "View"}
                                                            </Button>
                                                        )} */}
                                                        </Box>
                                                        <Typography sx={{ fontWeight: 400, fontSize: '10px', mt: 0.5, textAlign: 'end', color: '#5b4200' }}>
                                                            {formatTime(notification.timestamp)}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <hr style={{ border: '1px solid #E6E6E8' }} />
                                            </div>
                                        ))}
                                    </>
                                )}
                                {groupedNotifications.thisWeek.length > 0 && (
                                    <>
                                        <Typography
                                            sx={{
                                                fontSize: "10px",
                                                fontWeight: 400,
                                                textAlign: "center",
                                                mt: 1,
                                                color: "#5b4200"
                                            }}
                                        >
                                            This Week
                                        </Typography>
                                        {groupedNotifications.thisWeek.map((notification: any, index: number) => (
                                            <div key={notification.id}>
                                                <Grid container spacing={2} sx={{ mt: index === 0 ? 1 : 0 }} onClick={() => { markIndividualAsRead(notification.id); navigate(`${notification.url}`); handleClosePopover(); }}>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                                        <Box sx={{ height: '42px', width: '42px' }}>
                                                            {tabIndex === 0 ? (
                                                                <div
                                                                    style={{
                                                                        // backgroundColor: notification.title === "margin_approved" ? '#EBF4EC' : "#fbeaea",

                                                                        display: "flex",

                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        width: "42px",
                                                                        height: "42px",
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={notification.imageUrl === "null" ? defultNotification : notification.imageUrl === "null" ? defultNotification : notification.imageUrl || defultNotification}
                                                                        style={{ width: notification.imageUrl === "null" || !notification.imageUrl ? "30px" : "40px", height: notification.imageUrl === "null" || !notification.imageUrl ? "40px" : "40px", border: notification.imageUrl === "null" || !notification.imageUrl ? undefined : "1px solid #5b4200", borderRadius: "10px" }}
                                                                        alt="alert"
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <img
                                                                    src={notification.imageUrl === "null" ? defultNotification : notification.imageUrl || defultNotification}
                                                                    height={'100%'}
                                                                    width={'100%'}
                                                                    style={{ borderRadius: '50%' }}
                                                                    alt="profile"
                                                                />
                                                            )}
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={7} sm={7} md={7} lg={7} xl={7} xxl={6.5} style={{ textAlign: 'left' }}>
                                                        <Typography sx={{ color: '#5b4200', fontWeight: 500, fontSize: '12px' }}>
                                                            {formatTitle(notification.title)}
                                                        </Typography>
                                                        <Typography sx={{ fontWeight: 400, fontSize: '11px', mt: 0.5, color: '#5b4200' }}>
                                                            {notification.body}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3} xxl={3.5}>
                                                        {/* <Box sx={{ display: 'flex' }}>
                                                        {(notification.templateId !== "ewaybill_expiry_in_app" || role === "SUB_BRANCH_USER") && (
                                                            <Button
                                                                size="small"
                                                                sx={{
                                                                    height: '20px',
                                                                    width: '3vw',
                                                                    borderRadius: '8px',
                                                                    padding: 0,
                                                                    minWidth: '3vw',
                                                                    backgroundColor: '#5b4200',
                                                                    '&:hover': {
                                                                        backgroundColor: '#5b4200',
                                                                        color: 'white',
                                                                    },
                                                                    color: 'white',
                                                                    fontSize: '8px',
                                                                    fontWeight: '500',
                                                                    textTransform: 'none',
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    if (unreadNotifications.includes(notification.id)) {
                                                                        markIndividualAsRead(notification.id);
                                                                    }
                                                                    notification?.navigatingFunction(
                                                                        notification.url,
                                                                        notification.title,
                                                                        notification.body,
                                                                        notification.id,
                                                                        notification.templateId
                                                                    );
                                                                }}
                                                            >
                                                                {notification.title === "margin_approval_request" ? "Take Action" : "View"}
                                                            </Button>
                                                        )}
                                                    </Box> */}
                                                        <Typography sx={{ fontWeight: 400, fontSize: '10px', mt: 0.5, textAlign: 'end', color: '#5b4200' }}>
                                                            {formatTime(notification.timestamp)}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <hr style={{ border: '1px solid #E6E6E8' }} />
                                            </div>
                                        ))}
                                    </>
                                )}
                                {groupedNotifications.earlier.length > 0 && (
                                    <>
                                        <Typography
                                            sx={{
                                                fontSize: "10px",
                                                fontWeight: 400,
                                                textAlign: "center",
                                                mt: 1,
                                                color: "#5b4200"
                                            }}
                                        >
                                            Earlier
                                        </Typography>
                                        {groupedNotifications.earlier.map((notification: any, index: number) => (
                                            <div key={notification.id}>
                                                <Grid container spacing={2} sx={{ mt: index === 0 ? 1 : 0 }} onClick={() => { markIndividualAsRead(notification.id); navigate(`${notification.url}`); handleClosePopover(); }}>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                                        <Box sx={{ height: '42px', width: '42px' }}>
                                                            {tabIndex === 0 ? (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        width: "42px",
                                                                        height: "42px",
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={notification.imageUrl === "null" ? defultNotification : notification.imageUrl === "null" ? defultNotification : notification.imageUrl || defultNotification}
                                                                        style={{ width: notification.imageUrl === "null" || !notification.imageUrl ? "30px" : "40px", height: notification.imageUrl === "null" || !notification.imageUrl ? "40px" : "40px", border: notification.imageUrl === "null" || !notification.imageUrl ? undefined : "1px solid #5b4200", borderRadius: "10px" }}
                                                                        alt="alert"
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <img
                                                                    src={notification.imageUrl === "null" ? defultNotification : notification.imageUrl || defultNotification}
                                                                    height={'100%'}
                                                                    width={'100%'}
                                                                    style={{ borderRadius: '50%' }}
                                                                    alt="profile"
                                                                />
                                                            )}
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={7} sm={7} md={7} lg={7} xl={7} xxl={6.5} style={{ textAlign: 'left' }}>
                                                        <Typography sx={{ color: '#5b4200', fontWeight: 500, fontSize: '12px' }}>
                                                            {formatTitle(notification.title)}
                                                        </Typography>
                                                        <Typography sx={{ fontWeight: 400, fontSize: '11px', mt: 0.5, color: '#5b4200' }}>
                                                            {notification.body}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3} xxl={3.5}>
                                                        {/* <Box sx={{ display: 'flex' }}>
                                                        {(notification.templateId !== "ewaybill_expiry_in_app" || role === "SUB_BRANCH_USER") && (
                                                            <Button
                                                                size="small"
                                                                sx={{
                                                                    height: '20px',
                                                                    width: '3vw',
                                                                    borderRadius: '8px',
                                                                    padding: 0,
                                                                    minWidth: '3vw',
                                                                    backgroundColor: '#5b4200',
                                                                    '&:hover': {
                                                                        backgroundColor: '#5b4200',
                                                                        color: 'white',
                                                                    },
                                                                    color: 'white',
                                                                    fontSize: '8px',
                                                                    fontWeight: '500',
                                                                    textTransform: 'none',
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    if (unreadNotifications.includes(notification.id)) {
                                                                        markIndividualAsRead(notification.id);
                                                                    }
                                                                    notification?.navigatingFunction(
                                                                        notification.url,
                                                                        notification.title,
                                                                        notification.body,
                                                                        notification.id,
                                                                        notification.templateId
                                                                    );
                                                                }}
                                                            >
                                                                {notification.title === "margin_approval_request" ? "Take Action" : "View"}
                                                            </Button>
                                                        )}
                                                    </Box> */}
                                                        <Typography sx={{ fontWeight: 400, fontSize: '10px', mt: 0.5, textAlign: 'end', color: '#5b4200' }}>
                                                            {formatTime(notification.timestamp)}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <hr style={{ border: '1px solid #E6E6E8' }} />
                                            </div>
                                        ))}
                                    </>
                                )}
                                {isFetchingMore && (
                                    <div
                                        style={{
                                            marginTop: "-20px",
                                            textAlign: "center",
                                        }}
                                    >
                                        <span style={{ color: "#5b4200" }}>Loading ...</span>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
                {(tabIndex === 1 || tabIndex === 2) && (
                    <>
                        {loading ? (
                            <div style={{ textAlign: "center" }}>
                                <span>
                                    <img alt="" src={notify_loader} width="100px" height="100px"></img>
                                </span>
                            </div>
                        ) : filteredNotifications.length === 0 ? (
                            <div style={{ textAlign: "center" }}>
                                <div>
                                    <img alt="" src={emptyNotification} width="200px" height="200px" />
                                </div>
                                <div style={{ fontSize: "14px", color: "#373A45" }}>
                                    You're all caught up! No new notifications at the moment.
                                </div>
                            </div>
                        ) : (
                            <>
                                {/* Use groupedFilteredNotifications for Unread/Read */}
                                {groupedFilteredNotifications.today.length > 0 && (
                                    <>
                                        <Typography
                                            sx={{
                                                fontSize: "10px",
                                                fontWeight: 400,
                                                textAlign: "center",
                                                mt: 1,
                                                color: "#5b4200"
                                            }}
                                        >
                                            Today
                                        </Typography>
                                        {groupedFilteredNotifications.today.map((notification: any, index: number) => (
                                            <div key={notification.id}>
                                                <Grid container spacing={2} sx={{ mt: index === 0 ? 1 : 0 }} onClick={() => { markIndividualAsRead(notification.id); navigate(`${notification.url}`); handleClosePopover(); }}>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                                        <Box sx={{ height: '42px', width: '42px' }}>
                                                            <img
                                                                src={notification.imageUrl === "null" ? defultNotification : notification.imageUrl || defultNotification}
                                                                height={'35px'}
                                                                width={'35px'}
                                                                style={{ borderRadius: '50%' }}
                                                                alt="profile"
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={7} sm={7} md={7} lg={7} xl={7} xxl={6.5} style={{ textAlign: 'left' }}>
                                                        <Typography sx={{ color: '#5b4200', fontWeight: 500, fontSize: '12px' }}>
                                                            {formatTitle(notification.title)}
                                                        </Typography>
                                                        <Typography sx={{ fontWeight: 400, fontSize: '11px', mt: 0.5, color: '#5b4200' }}>
                                                            {notification.body}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3} xxl={3.5}>
                                                        <Box sx={{ display: 'flex' }}>
                                                            {/* <Button
                                                            size="small"
                                                            sx={{
                                                                height: '20px',
                                                                width: '3vw',
                                                                borderRadius: '8px',
                                                                padding: 0,
                                                                minWidth: '3vw',
                                                                backgroundColor: '#5b4200',
                                                                '&:hover': {
                                                                    backgroundColor: '#5b4200',
                                                                    color: 'white',
                                                                },
                                                                color: 'white',
                                                                fontSize: '8px',
                                                                fontWeight: '500',
                                                                textTransform: 'none',
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                if (unreadNotifications.includes(notification.id)) {
                                                                    markIndividualAsRead(notification.id);
                                                                }
                                                                notification?.navigatingFunction(
                                                                    notification.url,
                                                                    notification.title,
                                                                    notification.body,
                                                                    notification.id,
                                                                    notification.templateId
                                                                );
                                                            }}
                                                        >
                                                            View
                                                        </Button> */}
                                                        </Box>
                                                        <Typography sx={{ fontWeight: 400, fontSize: '10px', mt: 0.5, textAlign: 'end', color: '#5b4200' }}>
                                                            {formatTime(notification.timestamp)}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <hr style={{ border: '1px solid #E6E6E8' }} />
                                            </div>
                                        ))}
                                    </>
                                )}
                                {groupedFilteredNotifications.yesterday.length > 0 && (
                                    <>
                                        <Typography
                                            sx={{
                                                fontSize: "10px",
                                                fontWeight: 400,
                                                textAlign: "center",
                                                mt: 1,
                                                color: "#5b4200"
                                            }}
                                        >
                                            Yesterday
                                        </Typography>
                                        {groupedFilteredNotifications.yesterday.map((notification: any, index: number) => (
                                            <div key={notification.id}>
                                                <Grid container spacing={2} sx={{ mt: index === 0 ? 1 : 0 }} onClick={() => { markIndividualAsRead(notification.id); navigate(`${notification.url}`); handleClosePopover(); }}>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                                        <Box sx={{ height: '42px', width: '42px' }}>
                                                            <img
                                                                src={notification.imageUrl === "null" ? defultNotification : notification.imageUrl || defultNotification}
                                                                height={'100%'}
                                                                width={'100%'}
                                                                style={{ borderRadius: '50%' }}
                                                                alt="profile"
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={7} sm={7} md={7} lg={7} xl={7} xxl={6.5} style={{ textAlign: 'left' }}>
                                                        <Typography sx={{ color: '#5b4200', fontWeight: 500, fontSize: '12px' }}>
                                                            {formatTitle(notification.title)}
                                                        </Typography>
                                                        <Typography sx={{ fontWeight: 400, fontSize: '11px', mt: 0.5, color: '#5b4200' }}>
                                                            {notification.body}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3} xxl={3.5}>
                                                        <Box sx={{ display: 'flex' }}>
                                                            {/* <Button
                                                            size="small"
                                                            sx={{
                                                                height: '20px',
                                                                width: '3vw',
                                                                borderRadius: '8px',
                                                                padding: 0,
                                                                minWidth: '3vw',
                                                                backgroundColor: '#5b4200',
                                                                '&:hover': {
                                                                    backgroundColor: '#5b4200',
                                                                    color: 'white',
                                                                },
                                                                color: 'white',
                                                                fontSize: '8px',
                                                                fontWeight: '500',
                                                                textTransform: 'none',
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                if (unreadNotifications.includes(notification.id)) {
                                                                    markIndividualAsRead(notification.id);
                                                                }
                                                                notification?.navigatingFunction(
                                                                    notification.url,
                                                                    notification.title,
                                                                    notification.body,
                                                                    notification.id,
                                                                    notification.templateId
                                                                );
                                                            }}
                                                        >
                                                            View
                                                        </Button> */}
                                                        </Box>
                                                        <Typography sx={{ fontWeight: 400, fontSize: '10px', mt: 0.5, textAlign: 'end', color: '#5b4200' }}>
                                                            {formatTime(notification.timestamp)}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <hr style={{ border: '1px solid #E6E6E8' }} />
                                            </div>
                                        ))}
                                    </>
                                )}
                                {groupedFilteredNotifications.thisWeek.length > 0 && (
                                    <>
                                        <Typography
                                            sx={{
                                                fontSize: "10px",
                                                fontWeight: 400,
                                                textAlign: "center",
                                                mt: 1,
                                                color: "#5b4200"
                                            }}
                                        >
                                            This Week
                                        </Typography>
                                        {groupedFilteredNotifications.thisWeek.map((notification: any, index: number) => (
                                            <div key={notification.id}>
                                                <Grid container spacing={2} sx={{ mt: index === 0 ? 1 : 0 }} onClick={() => { markIndividualAsRead(notification.id); navigate(`${notification.url}`); handleClosePopover(); }}>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                                        <Box sx={{ height: '42px', width: '42px' }}>
                                                            <img
                                                                src={notification.imageUrl === "null" ? defultNotification : notification.imageUrl || defultNotification}
                                                                height={'100%'}
                                                                width={'100%'}
                                                                style={{ borderRadius: '50%' }}
                                                                alt="profile"
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={7} sm={7} md={7} lg={7} xl={7} xxl={6.5} style={{ textAlign: 'left' }}>
                                                        <Typography sx={{ color: '#5b4200', fontWeight: 500, fontSize: '12px' }}>
                                                            {formatTitle(notification.title)}
                                                        </Typography>
                                                        <Typography sx={{ fontWeight: 400, fontSize: '11px', mt: 0.5, color: '#5b4200' }}>
                                                            {notification.body}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3} xxl={3.5}>
                                                        <Box sx={{ display: 'flex' }}>
                                                            {/* <Button
                                                            size="small"
                                                            sx={{
                                                                height: '20px',
                                                                width: '3vw',
                                                                borderRadius: '8px',
                                                                padding: 0,
                                                                minWidth: '3vw',
                                                                backgroundColor: '#5b4200',
                                                                '&:hover': {
                                                                    backgroundColor: '#5b4200',
                                                                    color: 'white',
                                                                },
                                                                color: 'white',
                                                                fontSize: '8px',
                                                                fontWeight: '500',
                                                                textTransform: 'none',
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                if (unreadNotifications.includes(notification.id)) {
                                                                    markIndividualAsRead(notification.id);
                                                                }
                                                                notification?.navigatingFunction(
                                                                    notification.url,
                                                                    notification.title,
                                                                    notification.body,
                                                                    notification.id,
                                                                    notification.templateId
                                                                );
                                                            }}
                                                        >
                                                            View
                                                        </Button> */}
                                                        </Box>
                                                        <Typography sx={{ fontWeight: 400, fontSize: '10px', mt: 0.5, textAlign: 'end', color: '#5b4200' }}>
                                                            {formatTime(notification.timestamp)}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <hr style={{ border: '1px solid #E6E6E8' }} />
                                            </div>
                                        ))}
                                    </>
                                )}
                                {groupedFilteredNotifications.earlier.length > 0 && (
                                    <>
                                        <Typography
                                            sx={{
                                                fontSize: "10px",
                                                fontWeight: 400,
                                                textAlign: "center",
                                                mt: 1,
                                                color: "#5b4200"
                                            }}
                                        >
                                            Earlier
                                        </Typography>
                                        {groupedFilteredNotifications.earlier.map((notification: any, index: number) => (
                                            <div key={notification.id}>
                                                <Grid container spacing={2} sx={{ mt: index === 0 ? 1 : 0 }} onClick={() => { markIndividualAsRead(notification.id); navigate(`${notification.url}`); handleClosePopover(); }}>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                                        <Box sx={{ height: '42px', width: '42px' }}>
                                                            <img
                                                                src={notification.imageUrl === "null" ? defultNotification : notification.imageUrl || defultNotification}
                                                                height={'100%'}
                                                                width={'100%'}
                                                                style={{ borderRadius: '50%' }}
                                                                alt="profile"
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={7} sm={7} md={7} lg={7} xl={7} xxl={6.5} style={{ textAlign: 'left' }}>
                                                        <Typography sx={{ color: '#5b4200', fontWeight: 500, fontSize: '12px' }}>
                                                            {formatTitle(notification.title)}
                                                        </Typography>
                                                        <Typography sx={{ fontWeight: 400, fontSize: '11px', mt: 0.5, color: '#5b4200' }}>
                                                            {notification.body}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3} xxl={3.5}>
                                                        <Box sx={{ display: 'flex' }}>
                                                            {/* <Button
                                                            size="small"
                                                            sx={{
                                                                height: '20px',
                                                                width: '3vw',
                                                                borderRadius: '8px',
                                                                padding: 0,
                                                                minWidth: '3vw',
                                                                backgroundColor: '#5b4200',
                                                                '&:hover': {
                                                                    backgroundColor: '#5b4200',
                                                                    color: 'white',
                                                                },
                                                                color: 'white',
                                                                fontSize: '8px',
                                                                fontWeight: '500',
                                                                textTransform: 'none',
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                if (unreadNotifications.includes(notification.id)) {
                                                                    markIndividualAsRead(notification.id);
                                                                }
                                                                notification?.navigatingFunction(
                                                                    notification.url,
                                                                    notification.title,
                                                                    notification.body,
                                                                    notification.id,
                                                                    notification.templateId
                                                                );
                                                            }}
                                                        >
                                                            View
                                                        </Button> */}
                                                        </Box>
                                                        <Typography sx={{ fontWeight: 400, fontSize: '10px', mt: 0.5, textAlign: 'end', color: '#5b4200' }}>
                                                            {formatTime(notification.timestamp)}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <hr style={{ border: '1px solid #E6E6E8' }} />
                                            </div>
                                        ))}
                                    </>
                                )}
                                {isFetchingMore && (
                                    <div style={{ textAlign: "center", marginTop: "-20px" }}>
                                        <span style={{ color: "#5b4200" }}>Loading...</span>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
            </Box>
        </Box>
    );

    return (
        <>
            {openpop && (
                <ClickAwayListener onClickAway={handleClosePopover}>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: ismobile ? '70px' : '100px',
                            right: ismobile ? "5%" : '40px',
                            width: ismobile ? "90%" : 420,
                            height: ismobile ? "70%" : '60vh',
                            bgcolor: '#fff',
                            borderRadius: '20px',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                            p: 0,
                            zIndex: 1300,
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Grid container spacing={2} sx={{ backgroundColor: "#F7A70", p: 2 }}>
                            <Grid item xs={6} style={{ padding: "20px 20px 0px 15px", textAlign: "left" }}>
                                <Typography sx={{ fontSize: '15px', fontWeight: 500, color: '#373A45' }}>Notifications</Typography>
                            </Grid>
                            <Grid item xs={6} style={{ padding: "24px 0px 0px 10px", textAlign: "right" }}>
                                <Typography onClick={() => markAllAsSeen()} sx={{ fontSize: '12px', fontWeight: 400, color: '#2C60AA' }}>Mark all as read</Typography>
                            </Grid>
                        </Grid>
                        {notificationContent}
                    </Box>
                </ClickAwayListener>
            )}
        </>
    );
}; export default InAppNotifications;

